import _ from 'lodash';
import React, { useState, useEffect, memo } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PrettyPercent, PrettyNumberTZ } from 'components/Helpers';
import AnalyticsItem from './AnalyticsItem';

import styles from './Analytics.module.scss';

import { Box } from 'components/Wrapped';
import { withNamespaces } from 'react-i18next';
import { nestedTranslate } from 'utils/strings';
import { formatNumberToPlaces } from 'utils/numbers';
import { getSingleTradingPairSettings } from 'redux/selectors/settings';
import { getPricesByTradingPair } from 'redux/selectors/markets';

const currencySign = {
  USDT: '$',
  RUB: '₽',
};

const getCoinInfo = (props) => {
  const {
    t: translate,
    size,
    coinData,
    tradingPairSettings: { tickDecimals, orderValueDecimals },
  } = props;
  const t = nestedTranslate(translate, 'navbar.analyticsContainer');

  if (size === 'small') {
    return [
      {
        name: 'Макс (24ч)',
        item: coinData && (
          <Box pad="none" direction="row">
            {currencySign[coinData.quoteCurrency]}
            <PrettyNumberTZ number={formatNumberToPlaces(coinData.priceLow24h, tickDecimals)} />
          </Box>
        ),
      },
      {
        name: 'Мин (24ч)',
        item: coinData && (
          <Box pad="none" direction="row">
            {currencySign[coinData.quoteCurrency]}
            <PrettyNumberTZ number={formatNumberToPlaces(coinData.priceHigh24h, tickDecimals)} />
          </Box>
        ),
      },
      {
        name: `Объем (24ч)${coinData ? ` ${coinData.baseCurrency}` : ''}`,
        item: coinData && <PrettyNumberTZ number={formatNumberToPlaces(coinData.volume24h, orderValueDecimals)} />,
      },
      {
        name: `Объем (24ч)${coinData ? ` ${coinData.quoteCurrency}` : ''}`,
        item: coinData && <PrettyNumberTZ number={formatNumberToPlaces(coinData.volumeBaseCurrency24h, orderValueDecimals)} />,
      },
    ];
  }

  return [
    {
      name: t('lastPrice'),
      item: coinData && (
        <Box direction="row" pad="none">
          {currencySign[coinData.quoteCurrency]}
          <PrettyNumberTZ number={formatNumberToPlaces(coinData.lastPrice, tickDecimals)} />
        </Box>
      ),
    },
    {
      name: 'Изм (24ч)',
      item: coinData && (
        <Box pad="none" direction="row">
          <PrettyPercent value={coinData.priceChange24h} sign="" />
        </Box>
      ),
    },
    {
      name: 'Мин (24ч)',
      item: coinData && (
        <Box pad="none" direction="row">
          {currencySign[coinData.quoteCurrency]}
          <PrettyNumberTZ number={formatNumberToPlaces(coinData.priceHigh24h, tickDecimals)} />
        </Box>
      ),
    },
    {
      name: 'Макс (24ч)',
      item: coinData && (
        <Box pad="none" direction="row">
          {currencySign[coinData.quoteCurrency]}
          <PrettyNumberTZ number={formatNumberToPlaces(coinData.priceLow24h, tickDecimals)} />
        </Box>
      ),
    },
    {
      name: `Объем (24ч)${coinData ? ` ${coinData.baseCurrency}` : ''}`,
      item: coinData && <PrettyNumberTZ number={formatNumberToPlaces(coinData.volume24h, orderValueDecimals)} />,
    },
    {
      name: `Объем (24ч)${coinData ? ` ${coinData.quoteCurrency}` : ''}`,
      item: coinData && <PrettyNumberTZ number={formatNumberToPlaces(coinData.volumeBaseCurrency24h, orderValueDecimals)} />,
    },
  ];
};

const AnalyticsList = memo((props) => {
  const { size } = props;

  return getCoinInfo(props).map((val, index) => <AnalyticsItem key={index} data={val} size={size} />);
});

const Analytics = (props) => {
  const pricesByTradingPair = useSelector(getPricesByTradingPair);
  const [coinData, setCoinData] = useState(pricesByTradingPair);

  // todo: research времеменное решение
  useEffect(() => {
    const shouldUpdate = JSON.stringify(coinData) !== JSON.stringify(pricesByTradingPair);

    if (shouldUpdate) {
      setCoinData(pricesByTradingPair);
    }
  }, [coinData, pricesByTradingPair]);

  if (_.isEmpty(coinData)) {
    return null;
  }

  return (
    <div className={styles.analyticsContainer}>
      <AnalyticsList coinData={coinData} t={props.t} size={props.size} tradingPairSettings={props.tradingPairSettings} />
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    // markets,
    exchange,
    // exchangeSettings: { settings },
  } = state;

  return {
    // markets: markets,
    tradingPair: exchange.tradingPair,
    // tradingPairs: getMemoTradingPairs(state),
    tradingPairSettings: getSingleTradingPairSettings(state, {
      tradingPair: state.exchange.tradingPair,
    }),
    // mgokx: settings.mgokx,
    // prices: markets.prices,
    // quoteCurrency: exchange.tradingPair.quoteCurrency,
    // baseCurrency: exchange.tradingPair.baseCurrency,
  };
};

const AnalyticsContainer = withRouter(connect(mapStateToProps)(Analytics));

export default withNamespaces()(AnalyticsContainer);
